export { default } from './catalogBanner';
